import React, { createContext, useContext, useMemo, useState, useEffect } from "react";

export type Region = "global" | "emea";

interface RegionContextValue {
  region: Region;
}

const RegionContext = createContext<RegionContextValue>({ region: "global" });

export const RegionProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [region, setRegion] = useState<Region>("global");

  useEffect(() => {
    const pathname = window.location.pathname;
    setRegion(pathname.startsWith("/emea") ? "emea" : "global");
  }, []);

  const value = useMemo(() => ({ region }), [region]);

  return (
    <RegionContext.Provider value={value}>
      {children}
    </RegionContext.Provider>
  );
};

export const useRegion = () => useContext(RegionContext);

export const useRegionPrefix = () => {
  const { region } = useRegion();
  return region === 'emea' ? '/emea' : '';
};